<template>
	<div
		class="g-block-pay-jumplink-plus"
		:class="{
			'g-block-pay-jumplink-plus--edit': editable,
			'is-active': editable && active,
			'g-block-pay-jumplink-plus--fixed-viewport': fixedBottom && !editable,
			'g-block-pay-jumplink-plus--fixed-slot': fixedBottom && editable,
			'g-block-pay-jumplink-plus--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-pay-jumplink-plus__card" :style="cardStyle">
			<div class="g-block-pay-jumplink-plus__left">
				<div class="g-block-pay-jumplink-plus__icon" :style="iconStyle">
					<img
						v-if="iconImageUrl"
						:src="iconImageUrl"
						class="g-block-pay-jumplink-plus__icon-img"
						alt=""
					/>
					<i v-else :class="['mbm-iconfont', data.icon || 'mbm-tupian1']"></i>
				</div>
			</div>
			<div class="g-block-pay-jumplink-plus__info">
				<p class="g-block-pay-jumplink-plus__title">{{ data.title || 'AI创业交流群' }}</p>
				<p class="g-block-pay-jumplink-plus__subtitle">{{ data.subtitle || '每天更新实操案例' }}</p>
				<div class="g-block-pay-jumplink-plus__tags">
					<span
						v-for="(tag, index) in displayTags"
						:key="index"
						class="g-block-pay-jumplink-plus__tag"
						:style="getTagStyle(tag)"
					>{{ tag.text }}</span>
				</div>
			</div>
			<div class="g-block-pay-jumplink-plus__action">
				<div class="g-block-pay-jumplink-plus__right">
					<span v-if="!isGeditModulePaid && !shouldHidePrice" class="g-block-pay-jumplink-plus__price" :style="priceColor">¥ {{ displayPrice }}</span>
					<div
						class="g-block-pay-jumplink-plus__btn"
						:style="buttonStyle"
						@click.stop="onButtonClick"
					><span>{{ (isGeditModulePaid ? data.unlockedButtonText : '') || data.buttonText || '申请加入' }}</span> <span class="mbm-iconfont mbm-youjiantou1"></span></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import PayUnlockShell from '../shared/PayUnlockShell.vue';
	import { payUnlockMixin } from '../shared/mixin.js';
	import { formatPayPrice, getButtonColor } from '../shared/utils.js';
	import { getQiniuSignedUrl } from '../../../utils/qiniuMedia.js';
	import { navigateJumpLink } from '../../../utils/jumpLink.js';
	import { DEFAULT_PAY_UNLOCK_JUMPLINK } from '../../../templates.js';

	export default {
		name: 'GBlockPayUnlockJumpLinkPlus',
		components: { PayUnlockShell },
		mixins: [payUnlockMixin],
		computed: {
			defaultButtonColors() {
				return DEFAULT_PAY_UNLOCK_JUMPLINK;
			},
			displayPrice() {
				return formatPayPrice(this.data.price);
			},
			btnColor() {
				return this.data.buttonColor || '#F4242E';
			},
			priceColor() {
				return { color: this.data.buttonColor || '#F4242E' };
			},
			buttonStyle() {
				const bgColor = this.data.buttonColor || '#F4242E';
				if (this.isGeditModulePaid) {
					return {
						background: bgColor,
						color: '#fff',
					};
				}
				return {
					background: bgColor,
					color: '#fff',
				};
			},
			iconImageUrl() {
				const icon = this.data.iconImage;
				if (!icon) return '';
				if (typeof icon === 'string') return getQiniuSignedUrl(icon);
				return getQiniuSignedUrl(icon.previewUrl || icon.url || '');
			},
			cardStyle() {
				return {
					background: '#ffffff',
					boxShadow: `0 0 15px rgba(${this.hexToRgb(this.btnColor)}, 0.2)`,
				};
			},
			iconStyle() {
				return {
					background: '#f5f5f5',
					color: '#333',
				};
			},
			displayTags() {
				const tags = this.data.tags;
				if (Array.isArray(tags) && tags.length > 0) {
					return tags.filter(tag => tag && tag.text);
				}
				return [
					{ text: '长期有效', textColor: '#333' },
					{ text: '持续更新', textColor: '#666' },
				];
			},
		},
		methods: {
			hexToRgb(hex) {
				const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
				if (!result) return '0,0,0';
				return `${parseInt(result[1], 16)},${parseInt(result[2], 16)},${parseInt(result[3], 16)}`;
			},
			getTagStyle(tag) {
				return {
					background: 'rgba(0,0,0,0.08)',
					color: '#333',
				};
			},
			onButtonClick(e) {
				if (this.editable) {
					e?.stopPropagation?.();
					this.$emit('select');
					return;
				}
				if (this.isGeditModulePaid) {
					this.doJump();
				} else {
					this.runModulePayFlow();
				}
			},
			doJump() {
				if (this.data.jumpLink?.type) {
					navigateJumpLink(this.data.jumpLink, {
						apiRequest: this.$apiRequest,
					});
					return;
				}
				const jumpUrl = this.data.jumpUrl;
				if (!jumpUrl) {
					console.warn('JumpLinkPlus: 未配置跳转链接');
					return;
				}
				window.location.href = jumpUrl;
			},
			runModulePayFlow() {
				if (this.editable) return;
				if (!this.isGeditRealPay) return;
				if (this.isGeditModulePaid) return;
				const oId = this.geditPayModuleId;
				if (!oId) return;
				const requestPay = this.geditPay?.requestPay;
				if (typeof requestPay !== 'function') return;
				Promise.resolve(requestPay(oId)).catch(() => {});
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-pay-jumplink-plus {

		&--fixed-viewport,
		&--fixed-slot {
			padding: 0;
		}

		&--edit {
			border: 1px solid transparent;
			border-radius: 4px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}

		&--h5 {

			&.g-block-pay-jumplink-plus--fixed-viewport,
			&.g-block-pay-jumplink-plus--fixed-slot {
				padding: 0;
			}
		}
	}

	.g-block-pay-jumplink-plus__card {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 12px;
		border-radius: 10px;
		padding: 10px 10px;
	}

	.g-block-pay-jumplink-plus__left {
		flex-shrink: 0;
	}

	.g-block-pay-jumplink-plus__icon {
		width: 60px;
		height: 60px;
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		overflow: hidden;
	}

	.g-block-pay-jumplink-plus__icon-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.g-block-pay-jumplink-plus__icon .mbm-iconfont {
		font-size: 20px;
		color: #333;
	}

	.g-block-pay-jumplink-plus__info {
		flex: 1;
		min-width: 0;
		display: flex;
		flex-direction: column;
		gap: 4px;
	}

	.g-block-pay-jumplink-plus__title {
		margin: 0;
		font-size: 15px;
		font-weight: 700;
		color: #000;
		line-height: 1.4;
	}

	.g-block-pay-jumplink-plus__subtitle {
		margin: 0;
		font-size: 11px;
		color: #666;
		line-height: 1.4;
	}

	.g-block-pay-jumplink-plus__tags {
		display: flex;
		flex-wrap: wrap;
		gap: 6px;
	}

	.g-block-pay-jumplink-plus__tag {
		display: inline-flex;
		align-items: center;
		padding: 2px 8px;
		border-radius: 4px;
		font-size: 10px;
		line-height: 1.4;
		white-space: nowrap;
	}

	.g-block-pay-jumplink-plus__action {
		flex-shrink: 0;
		display: flex;
		align-items: center;
	}

	.g-block-pay-jumplink-plus__right {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		gap: 8px;
	}

	.g-block-pay-jumplink-plus__price {
		font-size: 20px;
		font-weight: 700;
		margin: 0 auto;
		line-height: 1.2;
	}

	.g-block-pay-jumplink-plus__btn {
		height: 30px;
		padding: 0 16px;
		border: none;
		border-radius: 999px;
		font-size: 12px;
		font-weight: 700;
		cursor: pointer;
		white-space: nowrap;
		text-align: center;
		display: flex;
		align-items: center;
	}

	.g-block-pay-jumplink-plus--h5 {
		.g-block-pay-jumplink-plus__card {
			gap: 0.24rem;
			border-radius: 0.2rem;
			padding: 0.2rem;
		}

		.g-block-pay-jumplink-plus__icon {
			width: 1.2rem;
			height: 1.2rem;
			border-radius: 0.16rem;
		}

		.g-block-pay-jumplink-plus__icon .mbm-iconfont {
			font-size: 0.36rem;
		}

		.g-block-pay-jumplink-plus__title {
			font-size: 0.30rem;
		}

		.g-block-pay-jumplink-plus__subtitle {
			font-size: 0.22rem;
		}

		.g-block-pay-jumplink-plus__tags {
			gap: 0.12rem;
		}

		.g-block-pay-jumplink-plus__tag {
			padding: 0.04rem 0.16rem;
			border-radius: 0.08rem;
			font-size: 0.2rem;
		}

		.g-block-pay-jumplink-plus__right {
			gap: 0.16rem;
		}

		.g-block-pay-jumplink-plus__price {
			font-size: 0.4rem;
		}

		.g-block-pay-jumplink-plus__btn {
			height: 0.6rem;
			padding: 0 0.32rem;
			font-size: 0.24rem;
		}
	}
</style>
